import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 flex flex-col items-center text-center">
        <h2 className="font-heading text-[32px] md:text-[48px] font-black text-foreground-900">
          加入桃桃漫画
        </h2>
        <p className="mt-3 text-base text-foreground-400">
          海量韩漫免费看，每天都有新惊喜
        </p>
        <Link
          to="/category/romance"
          className="mt-8 inline-flex items-center gap-2 h-[56px] px-10 bg-accent-500 text-white rounded-full text-[15px] font-semibold whitespace-nowrap hover:bg-accent-600 transition-colors cursor-pointer"
        >
          立即开始阅读
          <i className="ri-arrow-right-line" style={{ width: '16px', height: '16px' }} />
        </Link>

        <div className="mt-16 flex flex-wrap items-center justify-center gap-8 md:gap-16 opacity-30">
          <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center">
            <i className="ri-heart-3-fill text-primary-500 text-4xl md:text-5xl" style={{ width: '48px', height: '48px' }} />
          </div>
          <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center">
            <i className="ri-star-fill text-amber-400 text-4xl md:text-5xl" style={{ width: '48px', height: '48px' }} />
          </div>
          <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center">
            <i className="ri-emotion-happy-fill text-primary-500 text-4xl md:text-5xl" style={{ width: '48px', height: '48px' }} />
          </div>
          <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center">
            <i className="ri-book-open-fill text-accent-500 text-4xl md:text-5xl" style={{ width: '48px', height: '48px' }} />
          </div>
        </div>
      </div>
    </section>
  );
}